import ExcelJS from 'exceljs';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; 

// Exportar a Excel
export const exportToExcel = async (stats, period) => {
    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('Resumen');

    // Configurar anchos de columna (A=30, B=20)
    sheet.getColumn(1).width = 30; // Columna A
    sheet.getColumn(2).width = 20; // Columna B

    // Fila 1: Título (REPORTE DE DASHBOARD)
    sheet.mergeCells('A1:B1');
    const titleCell = sheet.getCell('A1');
    titleCell.value = 'REPORTE DE DASHBOARD';
    titleCell.font = { bold: true, color: { argb: 'FFFFFFFF' }, size: 14 };
    titleCell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF1E3A5F' } // #1e3a5f
    };
    titleCell.alignment = { horizontal: 'center', vertical: 'middle' };

    // Filas Período y Fecha
    sheet.addRow(['Período:', getPeriodName(period)]);
    sheet.addRow(['Fecha de generación:', new Date().toLocaleString()]);
    sheet.addRow([]);

    // Función auxiliar para títulos de sección (fondo gris claro #f0f0f0, negrita)
    const addSectionTitle = (title) => {
        const row = sheet.addRow([title]);
        const cell = row.getCell(1);
        cell.font = { bold: true };
        cell.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFF0F0F0' } 
        };
    };

    // VENTAS DEL PERÍODO
    addSectionTitle('VENTAS DEL PERÍODO');
    sheet.addRow(['Número de ventas:', stats.period.sales]);
    sheet.addRow(['Ingresos totales:', `S/. ${stats.period.revenue.toFixed(2)}`]);
    sheet.addRow(['Ganancia total:', `S/. ${stats.period.profit.toFixed(2)}`]);
    sheet.addRow(['Cambio vs semana anterior:', `${stats.period.revenueChange > 0 ? '+' : ''}${stats.period.revenueChange.toFixed(1)}%`]);
    sheet.addRow([]);

    // VENTAS DE HOY
    addSectionTitle('VENTAS DE HOY');
    sheet.addRow(['Número de ventas:', stats.today.sales]);
    sheet.addRow(['Ingresos:', `S/. ${stats.today.revenue.toFixed(2)}`]);
    sheet.addRow(['Ganancia:', `S/. ${stats.today.profit.toFixed(2)}`]);
    sheet.addRow([]);

    // INVENTARIO
    addSectionTitle('INVENTARIO');
    sheet.addRow(['Stock bajo:', stats.inventory.lowStock]);
    sheet.addRow(['Sin stock:', stats.inventory.outOfStock]);
    sheet.addRow([]);

    // CLIENTES
    addSectionTitle('CLIENTES');
    sheet.addRow(['Total clientes:', stats.customers.total]);

    // Hoja 2: Top Productos
    if (stats.topProducts && stats.topProducts.length > 0) {
        const sheet2 = workbook.addWorksheet('Top Productos');

        // Configurar anchos de columna
        sheet2.getColumn(1).width = 5;  // A
        sheet2.getColumn(2).width = 35; // B
        sheet2.getColumn(3).width = 12; // C
        sheet2.getColumn(4).width = 15; // D

        // Fila 1: Título
        sheet2.mergeCells('A1:D1');
        const titleCell2 = sheet2.getCell('A1');
        titleCell2.value = 'TOP 5 PRODUCTOS MÁS VENDIDOS';
        titleCell2.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        titleCell2.fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FF1E3A5F' }
        };
        titleCell2.alignment = { horizontal: 'center', vertical: 'middle' };

        // Fila 2: Vacía
        sheet2.addRow([]);

        // Fila 3: Encabezados
        const headersRow = sheet2.addRow(['#', 'Producto', 'Cantidad', 'Total Ventas']);
        headersRow.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: 'FF2980B9' }
            };
        });

        // Filas de datos
        stats.topProducts.forEach((product, index) => {
            const row = sheet2.addRow([
                index + 1,
                product.product_name,
                product.total_quantity,
                `S/. ${parseFloat(product.total_sales).toFixed(2)}`
            ]);

            // Filas alternas: blanco y gris muy claro (#f8f8f8)
            const bgColor = index % 2 === 0 ? 'FFFFFFFF' : 'FFF8F8F8';
            row.eachCell((cell) => {
                cell.fill = {
                    type: 'pattern',
                    pattern: 'solid',
                    fgColor: { argb: bgColor }
                };
            });
        });
    }
    // Hoja 3: Top Clientes
    if (stats.topCustomers && stats.topCustomers.length > 0) {
        const sheet3 = workbook.addWorksheet('Top Clientes');

        // Configurar anchos de columna
        sheet3.getColumn(1).width = 5;  // A
        sheet3.getColumn(2).width = 30; // B
        sheet3.getColumn(3).width = 12; // C
        sheet3.getColumn(4).width = 15; // D

        // Fila 1: Título
        sheet3.mergeCells('A1:D1');
        const titleCell3 = sheet3.getCell('A1');
        titleCell3.value = 'TOP 5 CLIENTES FRECUENTES';
        titleCell3.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        titleCell3.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E3A5F' } };
        titleCell3.alignment = { horizontal: 'center', vertical: 'middle' };

        // Fila 2: Vacía
        sheet3.addRow([]);

        // Fila 3: Encabezados
        const headersRow3 = sheet3.addRow(['#', 'Cliente', 'Compras', 'Total Gastado']);
        headersRow3.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        });

        // Filas de datos
        stats.topCustomers.forEach((customer, index) => {
            const row = sheet3.addRow([
                index + 1,
                customer.name,
                customer.purchase_count,
                `S/. ${parseFloat(customer.total_spent).toFixed(2)}`
            ]);

            const bgColor = index % 2 === 0 ? 'FFFFFFFF' : 'FFF8F8F8';
            row.eachCell((cell) => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
            });
        });
    }

    // Hoja 4: Ventas por Categoría
    if (stats.salesByCategory && stats.salesByCategory.length > 0) {
        const sheet4 = workbook.addWorksheet('Por Categoría');

        // Configurar anchos de columna
        sheet4.getColumn(1).width = 5;  // A
        sheet4.getColumn(2).width = 25; // B
        sheet4.getColumn(3).width = 12; // C
        sheet4.getColumn(4).width = 15; // D
        sheet4.getColumn(5).width = 12; // E

        // Fila 1: Título
        sheet4.mergeCells('A1:E1');
        const titleCell4 = sheet4.getCell('A1');
        titleCell4.value = 'VENTAS POR CATEGORÍA';
        titleCell4.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        titleCell4.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E3A5F' } };
        titleCell4.alignment = { horizontal: 'center', vertical: 'middle' };

        // Fila 2: Vacía
        sheet4.addRow([]);

        // Fila 3: Encabezados
        const headersRow4 = sheet4.addRow(['#', 'Categoría', 'Cantidad', 'Total Ventas', 'Porcentaje']);
        headersRow4.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        });

        // Filas de datos
        const total = stats.salesByCategory.reduce((sum, cat) => sum + parseFloat(cat.total_sales), 0);
        
        stats.salesByCategory.forEach((category, index) => {
            const percentage = (parseFloat(category.total_sales) / total) * 100;
            const row = sheet4.addRow([
                index + 1,
                category.category,
                category.total_quantity,
                `S/. ${parseFloat(category.total_sales).toFixed(2)}`,
                `${percentage.toFixed(1)}%`
            ]);

            const bgColor = index % 2 === 0 ? 'FFFFFFFF' : 'FFF8F8F8';
            row.eachCell((cell) => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
            });
        });
    }

    // Hoja 5: Ventas Diarias
    if (stats.salesChart && stats.salesChart.length > 0) {
        const sheet5 = workbook.addWorksheet('Ventas Diarias');

        // Configurar anchos de columna
        sheet5.getColumn(1).width = 18; // A
        sheet5.getColumn(2).width = 20; // B
        sheet5.getColumn(3).width = 15; // C

        // Fila 1: Título
        sheet5.mergeCells('A1:C1');
        const titleCell5 = sheet5.getCell('A1');
        titleCell5.value = 'VENTAS DIARIAS';
        titleCell5.font = { bold: true, color: { argb: 'FFFFFFFF' } };
        titleCell5.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1E3A5F' } };
        titleCell5.alignment = { horizontal: 'center', vertical: 'middle' };

        // Fila 2: Vacía
        sheet5.addRow([]);

        // Fila 3: Encabezados
        const headersRow5 = sheet5.addRow(['Fecha', 'Número de Ventas', 'Total']);
        headersRow5.eachCell((cell) => {
            cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF2980B9' } };
        });

        // Filas de datos
        stats.salesChart.forEach((day, index) => {
            const row = sheet5.addRow([
                new Date(day.date).toLocaleDateString(),
                day.sales_count,
                `S/. ${parseFloat(day.total_amount).toFixed(2)}`
            ]);

            const bgColor = index % 2 === 0 ? 'FFFFFFFF' : 'FFF8F8F8';
            row.eachCell((cell) => {
                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: bgColor } };
            });
        });
    }

    // Descargar archivo
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const fileName = `Dashboard_${getPeriodName(period)}_${new Date().toISOString().split('T')[0]}.xlsx`;
    
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    a.click();
    window.URL.revokeObjectURL(url);
};

// Exportar a PDF
export const exportToPDF = (stats, period) => {
    const doc = new jsPDF();
    
    // Título
    doc.setFontSize(20);
    doc.setFont('helvetica', 'bold');
    doc.text('REPORTE DE DASHBOARD', 105, 20, { align: 'center' });
    
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Período: ${getPeriodName(period)}`, 105, 28, { align: 'center' });
    doc.text(`Fecha: ${new Date().toLocaleString()}`, 105, 34, { align: 'center' });
    
    doc.line(20, 38, 190, 38);
    
    // Resumen de ventas
    let yPos = 45;
    
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.text('Ventas del Período', 20, yPos);
    
    yPos += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Número de ventas: ${stats.period.sales}`, 20, yPos);
    yPos += 6;
    doc.text(`Ingresos totales: S/. ${stats.period.revenue.toFixed(2)}`, 20, yPos);
    yPos += 6;
    doc.text(`Ganancia total: S/. ${stats.period.profit.toFixed(2)}`, 20, yPos);
    yPos += 6;
    
    const changeColor = stats.period.revenueChange >= 0 ? [39, 174, 96] : [231, 76, 60];
    doc.setTextColor(...changeColor);
    doc.text(`Cambio vs período anterior: ${stats.period.revenueChange > 0 ? '+' : ''}${stats.period.revenueChange.toFixed(1)}%`, 20, yPos);
    doc.setTextColor(0, 0, 0);
    
    yPos += 12;
    
    // Top Productos
    if (stats.topProducts.length > 0) {
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Top 5 Productos Más Vendidos', 20, yPos);
        yPos += 5;
        
        const productosData = stats.topProducts.map((p, i) => [
            i + 1,
            p.product_name,
            p.total_quantity,
            `S/. ${parseFloat(p.total_sales).toFixed(2)}`
        ]);
        
        autoTable(doc, {
            startY: yPos,
            head: [['#', 'Producto', 'Cantidad', 'Total']],
            body: productosData,
            theme: 'striped',
            headStyles: { fillColor: [52, 152, 219] }
        });
        
        yPos = doc.lastAutoTable.finalY + 10;
    }
    
    // Top Clientes
    if (stats.topCustomers.length > 0 && yPos < 250) {
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Top 5 Clientes Frecuentes', 20, yPos);
        yPos += 5;
        
        const clientesData = stats.topCustomers.map((c, i) => [
            i + 1,
            c.name,
            c.purchase_count,
            `S/. ${parseFloat(c.total_spent).toFixed(2)}`
        ]);
        
        autoTable(doc, {
            startY: yPos,
            head: [['#', 'Cliente', 'Compras', 'Total']],
            body: clientesData,
            theme: 'striped',
            headStyles: { fillColor: [52, 152, 219] }
        });
    }
    
    // Nueva página para categorías si es necesario
    if (stats.salesByCategory && stats.salesByCategory.length > 0) {
        doc.addPage();
        yPos = 20;
        
        doc.setFontSize(14);
        doc.setFont('helvetica', 'bold');
        doc.text('Ventas por Categoría', 20, yPos);
        yPos += 5;
        
        const total = stats.salesByCategory.reduce((sum, cat) => sum + parseFloat(cat.total_sales), 0);
        const categoriasData = stats.salesByCategory.map((c, i) => {
            const percentage = (parseFloat(c.total_sales) / total) * 100;
            return [
                i + 1,
                c.category,
                c.total_quantity,
                `S/. ${parseFloat(c.total_sales).toFixed(2)}`,
                `${percentage.toFixed(1)}%`
            ];
        });
        
        autoTable(doc, {
            startY: yPos,
            head: [['#', 'Categoría', 'Cantidad', 'Total', '%']],
            body: categoriasData,
            theme: 'striped',
            headStyles: { fillColor: [52, 152, 219] }
        });
    }
    
    // Descargar
    const fileName = `Dashboard_${getPeriodName(period)}_${new Date().toISOString().split('T')[0]}.pdf`;
    doc.save(fileName);
};

// Función auxiliar para obtener nombre del período
const getPeriodName = (period) => {
    switch(period) {
        case 'today': return 'Hoy';
        case 'week': return 'Esta Semana';
        case 'month': return 'Este Mes';
        case 'year': return 'Este Año';
        case 'custom': return 'Personalizado';
        default: return 'Este Mes';
    }
};